var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control-section"},[_c('pre',[_vm._v(_vm._s(_vm.templateContent))])])}
var staticRenderFns = []

export { render, staticRenderFns }